<template>
  <div
    class="effect-setting setting-popup"
    v-if='boxData.judgeBox'
    :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex}"
    @mousedown.stop.prevent
  >
    <div
      class="setting-popup__drag-area"
      @mousedown="moveStart($event, true)"
      @mousemove="moveArea($event)"
      @mouseup="saveMoveState($event)" :style="{'cursor': 'move'}"
    >
      基础
    </div>

    <div class="settting-popup__content">
      <ul class="items">
        <li class="item">
          <div class="item__title">透明度</div>
          <div class="item__main">
            <slider
              :runway-size="110"
              :number-unit="'%'"
              @updateValue="onTransparentUpdated"
              ref="transparentSlider"
            ></slider>
          </div>
        </li>
        <li
          class="item" v-if="false"
        >
          <div class="item__title">模糊度</div>
          <div class="item__main">
            <slider
              :runway-size="110"
              :number-unit="'%'"
              @updateValue="onBlurUpdated"
              ref="blurSlider"
            ></slider>
          </div>
        </li>

        <li
          class="item"
        >
          <div class="item__title">填充</div>
          <div class="item__main">
            <div class="color" @click="showColorPicker && showColorPicker({ whichPart: 'fill' })" :style="{backgroundColor: colorHex}"></div>
          </div>
        </li>
      </ul>
    </div>

    <div class="setting-popup__close" @click="close"><i class="icon-popup-close"></i></div>
    <div class="setting-popup__mask" v-show="isShowMask" @click="closeNextPopup('color')"></div>
  </div>
</template>

<script>
import popup from '../../mixins/popup.vue'
import slider from '../../popups/content/slider.vue'

export default {
  mixins: [popup],
  components: {
    slider
  },
  data () {
    return {
      popupType: 'basicSetting.bg',
      colorHex: '#5778fb',
      mainColor: '#5778fb'
    }
  },
  watch: {
    'boxData.judgeBox': {
      handler (val) {
        if (val) {
          this.$nextTick(() => {
            this.render();
          })
        }
      }
    },
    'SelectScenes_Msg.background.data.data.color': {
      handler (val) {
        this.colorHex = val || this.colorHex;
      }
    }
  },
  created () {
    this.$bus.on('colorPickerClosed', () => {
      this.isShowMask = false;
    });

    this.$bus.on(`colorPickerInput.${this.popupType}`, () => {

    });
  },
  methods: {
    render () {
      const vm = this;
      let {data, type} = this.SelectScenes_Msg.background.data || {};

      vm.$refs.transparentSlider
        && vm.$refs.transparentSlider.updateValFromOutside(this.getTransparent(data.opacity));

      vm.$refs.blurSlider
        && vm.$refs.blurSlider.updateValFromOutside(data.blur);

      if (type === 'Color') {
        this.colorHex = data.color || this.mainColor;
      } else {
        this.colorHex = this.mainColor;
      }
    },
    onTransparentUpdated (val, undo) {
      this.SelectScenes_Msg.setBackgroundOpacity(this.getOpacity(val), undo || false, undo);
    },
    onBlurUpdated (val, undo) {
      this.SelectScenes_Msg.setBackgroundBlur(val, undo || false, undo);
    },

    getTransparent (opacity) {
      return 100 - Math.round(opacity * 100)
    },
    getOpacity (transparence) {
      return (1 - transparence / 100).toFixed(2) - 0;
    },

    showColorPicker () {
      let data = this.SelectScenes_Msg.background.data.data;
      let color = data.color;
      this.$bus.emit('FeaturesPop_vue', {
        name: 'color',
        type: 1,
        posx: this.boxData.fix.x + 40,
        posy: this.boxData.fix.y + 40,
        scenes: true,
        color,
      });
      this.toggleMask(true);
    }
  }
}
</script>

<style lang="scss" scoped>
.setting-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 258px;
  min-height: 180px;
  z-index: 35;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  font-size: 14px;
  box-shadow: 0 0 3px 1px #d8dee9;
  color: #474261;

  &__drag-area {
    line-height: 28px;
    background: #d8dee9;
    text-align: left;
    text-indent: 14px;
    cursor: move;
  }

  &__close {
    position: absolute;
    top: 7px;
    right: 12px;
    height: 14px;
    line-height: 14px;
    width: 14px;
    cursor: pointer;
  }

  &__content {
    padding: 14px 0;
  }

  &__mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(#ffffff, 0.7);
  }
}

.items {
  padding-top: 25px;
}

.item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-left: 14px;
  padding-right: 14px;
  margin-bottom: 25px;

  &__title {
    flex-shrink: 0;
    width: 56px;
    margin-right: 10px;
    text-align: left;
  }
}

.color {
  width: 75px;
  height: 30px;
  border-radius: 4px;
  background-color: #5779fa;
  cursor: pointer;
  box-shadow: 0 0 3px 0px rgba(0,0,0,0.5);
}
</style>



// WEBPACK FOOTER //
// src/components/popupsNew/basicSetting.bg/basicSetting.bg.vue